import React, { forwardRef, useCallback, useRef } from "react";

export const BOOLEAN_QUERY_COLORS = {
  and: "#2e7d32", // &
  or: "#1565c0", // |
  not: "#c62828", // !
  paren: "#7b1fa2", // ( )
  phrase: "#ef6c00", // "..."
  word: "#212121",
};

const TOKEN_REGEX = /("[^"]*"?)|([&|!()])|([^\s&|!()"]+)|(\s+)/g;
const OPERATOR_KIND = { "&": "and", "|": "or", "!": "not", "(": "paren", ")": "paren" };

export const tokenizeBooleanQuery = (text) => {
  const tokens = [];
  for (const [value, phrase, operator, word] of text.matchAll(TOKEN_REGEX)) {
    const kind = phrase ? "phrase" : operator ? OPERATOR_KIND[operator] : word ? "word" : "space";
    tokens.push({ value, kind });
  }
  return tokens;
};

export const BooleanQueryText = ({ text }) =>
  tokenizeBooleanQuery(text).map((token, index) => (
    <span key={index} style={{ color: BOOLEAN_QUERY_COLORS[token.kind] }}>
      {token.value}
    </span>
  ));

export const BooleanQueryInput = forwardRef(function BooleanQueryInput(
  { className, value = "", onScroll, onKeyUp, onSelect, ...props },
  ref,
) {
  const overlayRef = useRef(null);

  const syncScroll = useCallback((e) => {
    if (overlayRef.current) overlayRef.current.scrollLeft = e.target.scrollLeft;
  }, []);

  return (
    <div style={{ position: "relative", display: "flex", flex: 1, minWidth: 0 }}>
      <div
        ref={overlayRef}
        aria-hidden="true"
        className={className}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
          overflow: "hidden",
          whiteSpace: "pre",
          pointerEvents: "none",
        }}
      >
        <BooleanQueryText text={value} />
      </div>
      <input
        {...props}
        ref={ref}
        value={value}
        className={className}
        spellCheck={false}
        onScroll={(e) => { syncScroll(e); onScroll?.(e); }}
        onKeyUp={(e) => { syncScroll(e); onKeyUp?.(e); }}
        onSelect={(e) => { syncScroll(e); onSelect?.(e); }}
        style={{
          position: "relative",
          flex: 1,
          minWidth: 0,
          color: "transparent",
          caretColor: BOOLEAN_QUERY_COLORS.word,
          background: "transparent",
        }}
      />
    </div>
  );
});
